import { render, staticRenderFns } from "./form.vue?vue&type=template&id=0690ea0e&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style0 from "./form.vue?vue&type=style&index=0&id=0690ea0e&lang=less&scoped=true"
import style1 from "./form.vue?vue&type=style&index=1&id=0690ea0e&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0690ea0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0690ea0e')) {
      api.createRecord('0690ea0e', component.options)
    } else {
      api.reload('0690ea0e', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=0690ea0e&scoped=true", function () {
      api.rerender('0690ea0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/order/b-free-order/form/form.vue"
export default component.exports